// @flow
import React from "react";
import CheckboxGroup from "./CheckboxGroup";
import { type Id } from "../../model";

import "./selecao-checkbox-base.css";

type Props = {
  nomeSelecao?: ?string,
  itens: Array<any>,
  campoId: string,
  campoDescricao: string,
  onChange: (Array<Id>) => any,
  itensSelecionados?: Array<Id>,
};

export default function SelecaoCheckboxBase({
  nomeSelecao,
  itens,
  itensSelecionados,
  campoId,
  campoDescricao,
  onChange,
}: Props) {
  return (
    <div className="SelecaoCheckboxBase">
      {nomeSelecao && (
        <div className="SelecaoCheckboxBase__nome">{nomeSelecao}</div>
      )}
      <CheckboxGroup
        nome={
          nomeSelecao ? nomeSelecao.replace(/\s+/g, "-").toLowerCase() : null
        }
        itens={itens}
        itensSelecionados={itensSelecionados}
        onChange={onChange}
        campoId={campoId}
        campoDescricao={campoDescricao}
      />
    </div>
  );
}

SelecaoCheckboxBase.defaultProps = {
  campoId: "id",
  campoDescricao: "traducao",
};
